// extracted by mini-css-extract-plugin
module.exports = {"whw7f9r":"whw7f9r"};